module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-premium@2-09df43544a304d8e1ba1c199c27a4dcf.jpg";